import { getRandomKey } from "../features/randomUuidKey/randomUuidKey";

export async function fetchFullConfig() {
    const response: any = await fetch(`${process.env.PUBLIC_URL}/config.json?${getRandomKey()}`)
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Failed to load config");
    } else {
        return response.json()
    }
}